<template>
  <header class="main-header">
    <!-- Logo -->
    <a href="#" class="logo">
      <img src="../static/img/logo-small.png" style="height: 40px; float: left;" alt="Printer Counters" />
      <label style="font-size: 14px;">V. {{$root.version}}</label>
      <span class="label label-danger" @click="$root.confirmRefresh()" v-if="$root.hasNewVersion">1</span>
    </a>

    <!-- Header Navbar: style can be found in header.less -->
    <nav class="navbar navbar-static-top">
      <!-- Sidebar toggle button-->
      <a id="btnSidebarToggle" href="#" class="sidebar-toggle" data-toggle="push-menu" role="button">
        <span class="sr-only">Toggle navigation</span>
      </a>
      <a href="#" @click="$root.goto('Dashboard')" :class="['sidebar-toggle topMenu', activeMenu==='Dashboard'?'active':'']">
        <i class="fa fa-dashboard"></i>
        <span style="padding: 0px 10px; font-size: 14px;">Dashboard</span>
      </a>
      <a href="#" @click="$root.goto('Printers')" :class="['sidebar-toggle topMenu', (activeMenu==='Printers'||activeMenu==='Printer'||activeMenu==='PrinterHistory')?'active':'']">
        <i class="fa fa-print"></i>
        <span style="padding: 0px 10px; font-size: 14px;">Printers</span>
      </a>
      <a v-if="0>1" href="#" @click="$root.goto('TonerHistory')" :class="['sidebar-toggle topMenu', activeMenu==='TonerHistory'?'active':'']">
        <i class="fa fa-tint"></i>
        <span style="padding: 0px 10px; font-size: 14px;">Toner History</span>
      </a>
      <a href="#" @click="$root.goto('History')" :class="['sidebar-toggle topMenu', activeMenu==='History'?'active':'']">
        <i class="fa fa-history"></i>
        <span style="padding: 0px 10px; font-size: 14px;">Printers History</span>
      </a>
      <a href="#" @blur="testBlur('Reports')" @click="$root.goto('Reports')" :class="['sidebar-toggle topMenu', activeMenu==='Reports'?'active':'']">
        <i class="fa fa-bar-chart"></i>
        <span style="padding: 0px 10px; font-size: 14px;">Reports</span>
      </a>
      <a v-if="$root.isAdmin===9999" href="#" @click="$root.goto('ReportDesigner')" :class="['sidebar-toggle topMenu', activeMenu==='ReportDesigner'?'active':'']">
        <i class="fa fa-paint-brush"></i>
        <span style="padding: 0px 10px; font-size: 14px;">Designer</span>
      </a>
      <a v-if="$root.isAdmin" href="#" @click="$root.goto('Dealers')" :class="['sidebar-toggle topMenu', activeMenu==='Dealers'?'active':'']">
        <i class="fa fa-graduation-cap"></i>
        <span style="padding: 0px 10px; font-size: 14px;">Dealers</span>
      </a>
      <a v-if="$root.isAdmin || $root.isDealer || $root.isDealerAssistance" href="#" @click="$root.goto('Customers')" :class="['sidebar-toggle topMenu', activeMenu==='Customers'?'active':'']">
        <i class="fa fa-dollar"></i>
        <span style="padding: 0px 10px; font-size: 14px;">Customers</span>
      </a>
      <a v-if="$root.isAdmin || $root.isDealer || $root.isCustomer" href="#" @click="$root.goto('Sites')" :class="['sidebar-toggle topMenu', activeMenu==='Sites'?'active':'']">
        <i class="fa fa-map-marker"></i>
        <span style="padding: 0px 10px; font-size: 14px;">Sites</span>
      </a>
      <a v-if="$root.isAdmin || $root.isDealer || $root.isDealerAssistance" href="#" @click="$root.goto('Users')" :class="['sidebar-toggle topMenu', activeMenu==='Users'?'active':'']">
        <i class="fa fa-users"></i>
        <span style="padding: 0px 10px; font-size: 14px;">Users</span>
      </a>
      <a href="#" @click="$root.goto('Alerts')" :class="['sidebar-toggle topMenu', activeMenu==='Alerts'?'active':'']">
        <i class="fa fa-warning"></i>
        <span style="padding: 0px 10px; font-size: 14px;">Alerts</span>
      </a>
      <a v-if="$root.isAdmin || $root.isDealer || $root.isDealerAssistance" href="#" @click="$root.goto('Updates')" :class="['sidebar-toggle topMenu', activeMenu==='Updates'?'active':'']">
        <i v-if="$root.isAdmin" class="fa fa-upload"></i>
        <i v-else class="fa fa-download"></i>
        <span style="padding: 0px 10px; font-size: 14px;">Updates</span>
        <!--<span v-show="!$root.isAdmin" class="label label-danger">{{ remainTasksCount }}</span>-->
      </a>
      <!--<a href="#" @click="$root.goto('Support')" :class="['sidebar-toggle topMenu', activeMenu==='Support'?'active':'']">
    <i class="fa fa-commenting-o"></i>
    <span style="padding: 0px 10px; font-size: 14px;">Support</span>
  </a>-->
      <a v-if="$root.isAdmin" href="#" @click="$root.goto('Inbox')" :class="['sidebar-toggle topMenu', activeMenu==='Inbox'?'active':'']">
        <i class="fa fa-inbox"></i>
        <span style="padding: 0px 10px; font-size: 14px;">Inbox</span>
      </a>
      <!--<a href="#" @click="$root.goto('Account')" :class="['sidebar-toggle topMenu', activeMenu==='Account'?'active':'']">
    <i class="fa fa-sticky-note-o"></i>
    <span style="padding: 0px 10px; font-size: 14px;">Account</span>
  </a>-->
      <a href="#" @click="$root.goto('Contactus')" :class="['sidebar-toggle topMenu', activeMenu==='Contactus'?'active':'']">
        <i class="fa fa-sticky-note-o"></i>
        <span style="padding: 0px 10px; font-size: 14px;">Contact Us</span>
      </a>
      <!-- Navbar Right Menu -->
      <div class="navbar-custom-menu">
        <ul class="nav navbar-nav">
          <li v-if="alertsCount > 0" title="Your Email address is NOT Verified !">
            <a href="#" data-toggle="control-sidebar" @click="showAlert('Your Email address is NOT Verified !')">
              <i class="fa fa-exclamation-triangle"></i>
              <span class="label label-danger">{{ alertsCount }}</span>
            </a>
          </li>
          <li v-if="0>1" title="Settings" :class="[activeMenu==='Settings'?'active':'']">
            <a href="#" data-toggle="control-sidebar" @click="$root.goto('Settings')"><i class="fa fa-gears"></i></a>
          </li>
          <li class="dropdown user user-menu">
            <a href="#" data-toggle="dropdown" :class="['dropdown-toggle', activeMenu==='Account'?'active':'']">
              <span class="hidden-xs">{{ $root.userFullName }}</span>
              <img :src="logoPath" class="user-image roundImage" alt="User Image">
            </a>
            <ul class="dropdown-menu">
              <!-- User image -->
              <li class="user-header">
                <img :src="logoPath" class="user-image" alt="User Image">
                <p>{{ $root.userFullName }}</p>
              </li>
              <!-- Menu Footer-->
              <li class="user-footer">
                <div class="pull-left">
                  <a href="#" class="btn btn-default btn-flat" @click="$root.goto('Account')">Profile</a>
                </div>
                <div class="pull-right">
                  <a href="#" class="btn btn-default btn-flat" @click="$root.logout">Sign out</a>
                </div>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </nav>
  </header>
</template>

<script>
  export default {
    name: 'va-navibar',
    data () {
      return {
        alertsCount: 0,
        logoPath: 'https://image.flaticon.com/icons/png/512/149/149071.png'
      }
    },
    created () {
      console.log('navibar created')
    },
    mounted () {
      console.log('navibar mounted')
      if (this.$root.user) {
        if (!this.$root.user.Verified) {
          this.alertsCount = 1
        }
        if (this.$root.user.Logo) {
          this.logoPath = this.$root.user.Logo
        }
      }
    },
    updated () {
      console.log('navibar updated')
      // this.activeMenu = this.$root.activeMenu
    },
    ready () {
      console.log('navibar ready')
      // this.activeMenu = this.$root.activeMenu
    },
    computed: {
      activeMenu () {
        return this.$route.name
      }
    },
    watch: {
      activeMenu (val) {
        // this.$forceUpdate()
      }
    },
    methods: {
      testBlur (item) {
        // 'Reports'
        console.log('Blur ' + item)
      },
      showAlert (msg) {
        const vm = this
        vm.$bus.$emit('modal-open', {
          title: 'Warning Alert !',
          description: msg,
          type: 'modal-primary',
          confirmText: 'Close',
          // cancelText: 'Cancel',
          confirmBefore: () => {
            console.log('[Warning Alert] >>> confirmBefore')
          },
          confirmAfter: () => {
            console.log('[Warning Alert] >>> confirmAfter')
          },
          cancelBefore: () => {
            console.log('[Warning Alert] >>> cancelBefore')
          },
          cancelAfter: () => {
            console.log('[Warning Alert] >>> cancelAfter')
          }
        })
      }
    }
  }

</script>

<style scoped>
  .active {
    background-color: #367fa9;
  }
  a.topMenu:before {
    content: '';
  }
  a.topMenu > span {
    padding: 0px !important;
    font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
  }

  .user-header {
    height: 110px !important;
  }

  .sidebar-mini.sidebar-collapse .main-header .navbar {
    margin-left: 0px !important;
  }

  .sidebar-collapse .main-header .logo {
    width: 0px !important;
  }
</style>



// WEBPACK FOOTER //
// NaviBar.vue?79622b87